import authRoles from '@/app/auth/authRoles';
import React from 'react';
import UserManagement from './UserManagement';

const UserManagementConfig = {
	settings: {
		layout: {
			config: {},
		},
	},
	routes: [
		{
			path: '/user-management',
			element: (
				<React.Suspense fallback={<>...</>}>
					<UserManagement />
				</React.Suspense>
			),
		},
	],
	auth: authRoles.admin,
};

export default UserManagementConfig;
